import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';

import { gqlClient } from '@/api/graphql-client';
import { graphql } from '@/gql';
import {
  CreateOpenApiKeyMutation as _CreateOpenApiKeyMutation,
  CreateOpenApiKeyInput,
} from '@/gql/graphql';
import meKeys from '../../queries/me/keyFactory';

const CreateOpenApiKeyMutation = graphql(`
  mutation CreateOpenApiKey($input: CreateOpenApiKeyInput!) {
    createOpenApiKey(input: $input) {
      __typename
      ... on CreateOpenApiKeyResponseSuccess {
        clientId
        clientSecret
      }
      ... on CreateOpenApiKeyResponseError {
        message
      }
    }
  }
`);

const useCreateOpenApiKey = (
  options?: UseMutationOptions<
    _CreateOpenApiKeyMutation,
    unknown,
    CreateOpenApiKeyInput
  >
) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (variables) => {
      return gqlClient.request(CreateOpenApiKeyMutation, {
        input: variables,
      });
    },
    onSuccess: (data, variables, context) => {
      void queryClient.invalidateQueries({
        queryKey: meKeys.openApiKeys(),
      });
      options?.onSuccess?.(data, variables, context);
    },
    ...options,
  });
};

export default useCreateOpenApiKey;
